export enum SearchKeys {
  PAGE = "page",
  ROWS = "rows",
  STATUS = "status",
  COMPANY = "company",
  AUTH = "auth",
  ROLE = "role",
  REFERENCE = "ref",
}
